/**
 * Education-level enum and i18n label map.
 *
 * Extracted from common/constants.ts so this module can be imported in
 * test environments (jest/jsdom) without triggering the isChatEnabled
 * side-effect in common/constants that calls getConfig() at module load
 * time and crashes in jest.
 *
 * common/constants.ts re-exports everything from here, so existing
 * importers do not need to change.
 */
import { defineMessages, MessageDescriptor } from 'react-intl';

export enum EDUCATION_LEVEL {
  PRIMARY_SCHOOL = 'PRIMARY_SCHOOL',
  SECONDARY_SCHOOL = 'SECONDARY_SCHOOL',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  DIPLOMA = 'DIPLOMA',
  COLLEGE_DEGREE = 'COLLEGE_DEGREE',
  BACHELOR_DEGREE = 'BACHELOR_DEGREE',
  PROFESSIONAL_EDUCATION = 'PROFESSIONAL_EDUCATION',
  MASTER_DEGREE = 'MASTER_DEGREE',
  DOCTORATE = 'DOCTORATE',
  NO_PREFERENCE = 'NO_PREFERENCE',
}

export type TALENT_SEARCH_EDUCATION_LEVELS = Exclude<
  EDUCATION_LEVEL,
  EDUCATION_LEVEL.NO_PREFERENCE
>;

export const EDUCATION_LEVEL_MESSAGES: Record<
  EDUCATION_LEVEL,
  MessageDescriptor
> = defineMessages({
  [EDUCATION_LEVEL.PRIMARY_SCHOOL]: {
    id: 'interactive-primary-school',
    defaultMessage: 'Primary School',
  },
  [EDUCATION_LEVEL.SECONDARY_SCHOOL]: {
    id: 'interactive-secondary-school',
    defaultMessage: 'Secondary School',
  },
  [EDUCATION_LEVEL.HIGH_SCHOOL]: {
    id: 'interactive-high-vocational-school',
    defaultMessage: 'High School/ Vocational School',
  },
  [EDUCATION_LEVEL.DIPLOMA]: {
    id: 'interactive-diploma',
    defaultMessage: 'Diploma',
  },
  [EDUCATION_LEVEL.COLLEGE_DEGREE]: {
    id: 'interactive-college-degree',
    defaultMessage: 'College Degree',
  },
  [EDUCATION_LEVEL.BACHELOR_DEGREE]: {
    id: 'interactive-bachelors-degree',
    defaultMessage: "Bachelor's Degree",
  },
  [EDUCATION_LEVEL.PROFESSIONAL_EDUCATION]: {
    id: 'interactive-professional_education',
    defaultMessage: 'Professional Education Program',
  },
  [EDUCATION_LEVEL.MASTER_DEGREE]: {
    id: 'interactive-master-degree',
    defaultMessage: "Master's Degree",
  },
  [EDUCATION_LEVEL.DOCTORATE]: {
    id: 'interactive-doctorate',
    defaultMessage: 'Doctorate',
  },
  [EDUCATION_LEVEL.NO_PREFERENCE]: {
    id: 'interactive-no-preference',
    defaultMessage: 'No Preference',
  },
});
